<template>
  <div id="add-profession" class="lom-doc-upload">
    <v-card class="main-card overflow-hidden">
      <!-- Header -->
      <div class="premium-header premium-header--dialog">
        <span class="header-orb orb-1"></span>
        <span class="header-orb orb-2"></span>
        <div class="header-inner">
          <div class="header-left">
            <div class="glass-icon glass-icon--sm">
              <v-icon color="white" small>mdi-file-upload-outline</v-icon>
            </div>
            <div class="header-text">
              <div class="header-title header-title--sm">
                {{ pageTitle }}
              </div>
              <div class="header-subtitle">
                Upload the signed Nomination committee report as a PDF
              </div>
            </div>
          </div>

          <v-btn icon dark @click="closePrompt">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </div>
      </div>

      <v-card-text class="upload-body">
        <v-form ref="form1" v-model="valid1" lazy-validation id="createForm">
          <!-- Instructions -->
          <div class="instruction-card fade-up delay-1">
            <div class="instruction-head">
              <v-icon small color="#b45309" class="mr-2">mdi-information</v-icon>
              <h4 class="instruction-title">Upload File Instructions:</h4>
            </div>
            <h6 class="instruction-list">
              <span class="instruction-item">
                <span class="instruction-num">1</span>
                The Nomination committee report must be filled and signed by
                the IPP
              </span>
              <span class="instruction-item">
                <span class="instruction-num">2</span>
                The filled report should be uploaded in PDF format only
              </span>
              <span class="instruction-item">
                <span class="instruction-num">3</span>
                The file size should not exceed 2 MB
              </span>
            </h6>
          </div>

          <!-- Old document -->
          <div class="old-doc fade-up delay-2" v-if="OldDocumentFlag">
            <v-icon small color="#16a34a" class="mr-2">mdi-check-decagram</v-icon>
            <h5 class="old-doc-text">
              Download Your Old
              <a :href="rows.DocumentAssetPath" target="_blank">
                Nomination committee report
              </a>
              here
            </h5>
          </div>

          <!-- Drop zone -->
          <div class="drop-zone fade-up delay-3">
            <div class="drop-icon">
              <v-icon large color="#1565c0">mdi-cloud-upload-outline</v-icon>
            </div>
            <div class="drop-title">Select the signed report</div>
            <div class="drop-help">
              Upload the signed PDF of the Nomination committee report
              (PDF only, maximum 2 MB).
            </div>
            <div class="drop-input">
              <v-file-input
                :clearable="false"
                truncate-length="25"
                accept="application/pdf"
                placeholder="Upload pdf"
                v-model="UploadedFile1"
                prepend-icon="mdi-file-pdf"
              >
                <template v-slot:append-outer>
                  <v-icon color="red" @click="UploadedFile1 = {}">
                    mdi-delete
                  </v-icon>
                </template>
              </v-file-input>
            </div>
          </div>

          <upload-progress
            :ProgessStart="progessStart"
            :UploadPercentage="uploadPercentage"
          ></upload-progress>
        </v-form>
      </v-card-text>

      <!-- Footer -->
      <v-card-actions class="pa-4 action-buttons">
        <v-spacer></v-spacer>
        <v-btn
          @click="closePrompt"
          outlined
          color="grey darken-1"
          class="action-btn px-6 mr-3 font-weight-medium"
        >
          <v-icon left>mdi-close-circle</v-icon>
          Cancel
        </v-btn>
        <v-btn
          :disabled="!valid1"
          @click.prevent="submitForm"
          :loading="SubmitFlag"
          depressed
          color="success"
          class="action-btn btn-save btn-shine white--text px-6 font-weight-medium"
        >
          <v-icon left>mdi-content-save</v-icon>
          Save
        </v-btn>
      </v-card-actions>
    </v-card>
  </div>
</template>

<script>
import common from "@/view/Common.vue";
import companyConfig from "@/company_config.json";
import Swal from "sweetalert2";

export default {
  mixins: [common],
  components: {},
  props: {
    addRecordPrompt: {
      type: Boolean,
      required: true,
    },
    pageTitle: {
      type: String,
    },
    pageDescription: {
      type: String,
    },
  },
  data() {
    return {
      valid1: true,
      valid2: true,
      LoadingFlag: false,
      SearchFlag: false,
      SubmitFlag: false,

      ResultFlag: false,

      progessStart: 0,
      uploadPercentage: 0,

      rows: [],
      member: {},
      OldDocumentFlag: false,

      UploadedFile1: {},

      DocumentTypeRules: [(v) => !!v || "Document Type is required"],
      DocumentType: "",
      DocumentTypeOptions: [],
      DocumentTypeOptionsLoading: false,

      ReferenceNo: "",
      ReferenceNoRules: [(v) => !!v || "Reference No is required"],
    };
  },
  computed: {},
  watch: {},
  created() {
    // this.initialize()
  },
  methods: {
    validateForm() {
      console.log("validateForm called");
      this.$refs.form1.validate();
    },
    resetForm() {
      console.log("resetForm called");
      this.$refs.form1.reset();
      this.closePrompt();
    },
    resetValidation() {
      console.log("resetValidation called");
      this.$refs.form1.resetValidation();
    },
    resetUploadFile() {
      console.log("resetUploadFile called.");
      this.UploadFile = {};
    },
    closePrompt() {
      console.log("closePrompt called");
      // this.$emit('Member', this.NewMember);
      this.$emit("hideAddRecordPrompt", this.ResultFlag);
    },
    refreshPageData() {
      console.log("refreshPageData called");
      this.getTableRecords();
    },
    getTableRecords() {
      console.log("getTableRecords called");

      var validate = true;

      if (validate) {
        var server_url = companyConfig.apiURL;
        var token = this.$session.get("token");
        token = token == (null || undefined) ? 0 : token;
        var add_url = server_url + "api/lom-document/show";
        var upload = {
          UserInterface: 1,
        };
        console.log("upload=" + JSON.stringify(upload));
        console.log(
          "server_url=" +
            server_url +
            ", token=" +
            token +
            ", add_url=" +
            add_url
        );

        this.RecordFlag = false;

        const thisIns = this;
        var output = "";
        var records = "";
        var flag = 0;

        this.LoadingFlag = true;

        this.$http({
          url: add_url,
          method: "POST",
          data: upload,
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + token,
          },
          onUploadProgress: function (progressEvent) {
            this.uploadPercentage = parseInt(
              Math.round((progressEvent.loaded / progressEvent.total) * 100)
            );
          }.bind(this),
        })
          .then(function (response) {
            console.log("response=" + JSON.stringify(response));

            thisIns.LoadingFlag = false;

            output = response.data.output;
            flag = response.data.flag;
            records = response.data.records;
            console.log("output=" + output + ", flag=" + flag);

            thisIns.OldDocumentFlag = flag;

            if (flag == 1) {
              console.log("records=" + JSON.stringify(records));

              thisIns.rows = records;

              // thisIns.toast("success", output);
            } else {
              // thisIns.toast("error", output);
            }
          })
          .catch(function (error) {
            console.log("error=" + error);
            thisIns.toast("error", error);
            thisIns.LoadingFlag = false;
          });
      }
    },
    confirmAlert() {
      var validate1 = this.$refs.form1.validate();
      console.log("validate1=" + validate1);
      if (validate1) {
        Swal.fire({
          title: "Are you sure?",
          text: "You won't be able to revert this!",
          icon: "warning",
          showCancelButton: true,
          confirmButtonText: `Save`,
          confirmButtonColor: "#3085d6",
          cancelButtonText: `Cancel`,
          cancelButtonColor: "#d33",
        }).then((result) => {
          /* Read more about isConfirmed, isDenied below */
          if (result.isConfirmed) {
            this.submitForm();
          } else {
            this.sweetAlert("error", "You cancelled the process", true);
          }
        });
      } else {
        // this.toast("error", "Kindly fill the required fields", true);
      }
    },
    submitForm() {
      console.log("submitForm called");
      var validate1 = this.$refs.form1.validate();
      // var validate1 = true;
      console.log("validate1=" + validate1);
      var message = "";

      if (validate1) {
        var form = {};

        let upload = new FormData();
        upload.append("UserInterface", 1);
        upload.append("Form", JSON.stringify(form));
        upload.append("uploadFile1", this.UploadedFile1);

        console.log("upload=" + JSON.stringify(upload));

        this.SubmitFlag = true;
        this.ResultFlag = false;
        this.progessStart = 1;

        var server_url = companyConfig.apiURL;
        var token = this.$session.get("token");
        token = token == (null || undefined) ? 0 : token;
        var add_url = server_url + "api/lom-document/store";
        console.log(
          "server_url=" +
            server_url +
            ", token=" +
            token +
            ", add_url=" +
            add_url
        );

        console.log("upload=" + JSON.stringify(upload));

        const thisIns = this;
        var output = "";
        var flag = 0;

        this.$http({
          url: add_url,
          method: "POST",
          data: upload,
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: "Bearer " + token,
          },
          onUploadProgress: function (progressEvent) {
            this.uploadPercentage = parseInt(
              Math.round((progressEvent.loaded / progressEvent.total) * 100)
            );
          }.bind(this),
        })
          .then(function (response) {
            console.log("response=" + JSON.stringify(response));

            thisIns.SubmitFlag = false;
            thisIns.progessStart = 0;

            flag = response.data.flag;
            output = response.data.output;
            console.log("output=" + output + ", flag=" + flag);

            if (flag == 1) {
              thisIns.ResultFlag = true;
              thisIns.sweetAlert("success", output, true);
              thisIns.closePrompt();
            } else {
              thisIns.sweetAlert("error", output, false);
            }
          })
          .catch(function (error) {
            console.log("error=" + error);
            thisIns.SubmitFlag = false;
            thisIns.progessStart = 0;
          });
      } else {
        var message = "";
        if (!validate1) {
          message += "Kindly fill required fields.";
        }
        if (!uploadFile1) {
          message += "File is not selected";
        }
        this.sweetAlert("error", message, false);
      }
    },
  },
  beforeMount() {
    this.refreshPageData();
    this.member = {};
  },
};
</script>
<style lang="scss">
$primary-dark: #0b2a5b;
$primary: #1565c0;
$accent: #00b4d8;
$success: #16a34a;
$warning: #f59e0b;
$surface: #ffffff;
$page-bg: #f4f7fb;
$border: #e3e8ef;
$text-strong: #0f172a;
$text-muted: #64748b;
$shadow-soft: 0 1px 2px rgba(15, 23, 42, 0.06), 0 8px 24px rgba(15, 23, 42, 0.06);
$shadow-strong: 0 2px 4px rgba(15, 23, 42, 0.08), 0 16px 32px rgba(15, 23, 42, 0.14);
$header-gradient: linear-gradient(135deg, $primary-dark 0%, $primary 60%, $accent 100%);

@keyframes lgbFadeUp {
  from {
    opacity: 0;
    transform: translateY(16px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes lgbFadeIn {
  from {
    opacity: 0;
    transform: scale(0.85);
  }
  to {
    opacity: 1;
    transform: scale(1);
  }
}

@keyframes lgbPulse {
  0% {
    box-shadow: 0 0 0 0 rgba(245, 158, 11, 0.55);
  }
  70% {
    box-shadow: 0 0 0 10px rgba(245, 158, 11, 0);
  }
  100% {
    box-shadow: 0 0 0 0 rgba(245, 158, 11, 0);
  }
}

@keyframes lgbFloat {
  0%,
  100% {
    transform: translate(0, 0);
  }
  50% {
    transform: translate(12px, -10px);
  }
}

#add-profession.lom-doc-upload {
  .premium-header {
    position: relative;
    overflow: hidden;
    background: $header-gradient;
    color: #ffffff;
    padding: 22px 24px;

    .header-orb {
      position: absolute;
      border-radius: 50%;
      background: rgba(255, 255, 255, 0.12);
      filter: blur(2px);
      pointer-events: none;
      animation: lgbFloat 9s ease-in-out infinite;
    }

    .orb-1 {
      width: 220px;
      height: 220px;
      top: -110px;
      right: -40px;
    }

    .orb-2 {
      width: 140px;
      height: 140px;
      bottom: -80px;
      right: 22%;
      background: rgba(0, 180, 216, 0.22);
      animation-delay: 1.5s;
    }

    .orb-3 {
      width: 90px;
      height: 90px;
      top: 10px;
      left: 38%;
      background: rgba(255, 255, 255, 0.07);
      animation-delay: 3s;
    }

    .header-inner {
      position: relative;
      z-index: 1;
      display: flex;
      align-items: center;
      justify-content: space-between;
      gap: 16px;
      flex-wrap: wrap;
    }

    .header-left {
      display: flex;
      align-items: center;
      min-width: 0;
    }

    .glass-icon {
      flex: 0 0 48px;
      width: 48px;
      height: 48px;
      border-radius: 50%;
      display: flex;
      align-items: center;
      justify-content: center;
      margin-right: 14px;
      background: rgba(255, 255, 255, 0.15);
      border: 1px solid rgba(255, 255, 255, 0.25);
      backdrop-filter: blur(8px);
      animation: lgbFadeIn 0.5s ease-out both;

      &.glass-icon--sm {
        flex-basis: 38px;
        width: 38px;
        height: 38px;
      }
    }

    .header-title {
      font-size: 1.4rem;
      font-weight: 700;
      letter-spacing: 0.3px;
      line-height: 1.25;
      margin: 0;
      color: #ffffff;

      &.header-title--sm {
        font-size: 1.1rem;
      }
    }

    .header-subtitle {
      font-size: 0.85rem;
      opacity: 0.85;
      margin-top: 2px;
    }

    .glass-btn {
      height: 40px !important;
      border-radius: 10px !important;
      background: rgba(255, 255, 255, 0.16) !important;
      border: 1px solid rgba(255, 255, 255, 0.35);
      backdrop-filter: blur(8px);
      transition: transform 0.2s, box-shadow 0.2s, background 0.2s;

      &:hover {
        transform: translateY(-2px);
        background: rgba(255, 255, 255, 0.26) !important;
        box-shadow: 0 6px 16px rgba(0, 0, 0, 0.18);
      }
    }

    &.premium-header--dialog {
      padding: 16px 20px;
      position: sticky;
      top: 0;
      z-index: 5;
    }
  }

  .main-card {
    border-radius: 14px !important;
    overflow: hidden;
    box-shadow: $shadow-strong !important;
  }

  .upload-body {
    background: $page-bg;
    padding: 20px !important;
    color: $text-strong;
  }

  .fade-up {
    animation: lgbFadeUp 0.4s ease-out both;

    &.delay-1 {
      animation-delay: 0ms;
    }
    &.delay-2 {
      animation-delay: 80ms;
    }
    &.delay-3 {
      animation-delay: 160ms;
    }
  }

  .instruction-card {
    background: linear-gradient(90deg, rgba(245, 158, 11, 0.1) 0%, #ffffff 100%);
    border: 1px solid rgba(245, 158, 11, 0.3);
    border-left: 4px solid $warning;
    border-radius: 12px;
    padding: 14px 16px;
    margin-bottom: 16px;

    .instruction-head {
      display: flex;
      align-items: center;
      margin-bottom: 8px;
    }

    .instruction-title {
      margin: 0;
      font-size: 14px;
      font-weight: 700;
      color: #b45309;
    }

    .instruction-list {
      margin: 0;
      display: flex;
      flex-direction: column;
      gap: 6px;
      font-size: 13px;
      font-weight: 400;
      color: $text-muted;
    }

    .instruction-item {
      display: flex;
      align-items: flex-start;
      line-height: 1.5;
    }

    .instruction-num {
      flex: 0 0 20px;
      height: 20px;
      border-radius: 50%;
      margin-right: 8px;
      font-size: 11px;
      font-weight: 700;
      display: inline-flex;
      align-items: center;
      justify-content: center;
      color: #ffffff;
      background: $warning;
    }
  }

  .old-doc {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 10px 14px;
    margin-bottom: 16px;
    border: 1px solid rgba(22, 163, 74, 0.3);
    border-radius: 12px;
    background: rgba(22, 163, 74, 0.06);

    .old-doc-text {
      margin: 0;
      font-size: 13px;
      font-weight: 500;
      color: $text-strong;
    }

    a {
      font-weight: 700;
      color: $primary;
    }
  }

  .drop-zone {
    text-align: center;
    padding: 24px 20px 12px;
    border: 2px dashed rgba(21, 101, 192, 0.35);
    border-radius: 14px;
    background: $surface;
    transition: border-color 0.2s, box-shadow 0.2s, background 0.2s;

    &:hover {
      border-color: $primary;
      background: rgba(21, 101, 192, 0.03);
      box-shadow: $shadow-soft;
    }

    .drop-icon {
      width: 64px;
      height: 64px;
      margin: 0 auto 10px;
      border-radius: 50%;
      display: flex;
      align-items: center;
      justify-content: center;
      background: rgba(21, 101, 192, 0.08);
      animation: lgbFadeIn 0.5s ease-out both;
    }

    .drop-title {
      font-size: 15px;
      font-weight: 700;
      color: $text-strong;
    }

    .drop-help {
      font-size: 12px;
      color: $text-muted;
      margin-top: 4px;
    }

    .drop-input {
      max-width: 420px;
      margin: 8px auto 0;
    }
  }

  .action-buttons {
    position: sticky;
    bottom: 0;
    z-index: 5;
    background: $surface;
    border-top: 1px solid $border;
  }

  .action-btn {
    height: 40px !important;
    border-radius: 10px !important;
    text-transform: none;
    font-size: 14px;
    letter-spacing: 0.3px;
    transition: transform 0.2s, box-shadow 0.2s;

    &:hover {
      transform: translateY(-2px);
      box-shadow: 0 6px 16px rgba(15, 23, 42, 0.18) !important;
    }
  }

  .btn-save {
    background: linear-gradient(135deg, #15803d 0%, $success 60%, #22c55e 100%) !important;
  }

  .btn-shine {
    position: relative;
    overflow: hidden;

    &::after {
      content: "";
      position: absolute;
      top: 0;
      left: -75%;
      width: 50%;
      height: 100%;
      background: linear-gradient(
        120deg,
        rgba(255, 255, 255, 0) 0%,
        rgba(255, 255, 255, 0.45) 50%,
        rgba(255, 255, 255, 0) 100%
      );
      transform: skewX(-20deg);
      transition: left 0.6s ease;
    }

    &:hover::after {
      left: 125%;
    }
  }

  @media (prefers-reduced-motion: reduce) {
    * {
      animation: none !important;
      transition: none !important;
    }
  }
}
</style>
